export interface BranchLinksLocaleItem {
  main_footer_google_play?: string | null
  main_footer_app_store?: string | null
  main_footer_app_gallery?: string | null
  category_footer_google_play?: string | null
  category_footer_app_store?: string | null
  category_footer_app_gallery?: string | null
  sidebar_button?: string | null
}

export interface BranchLinks {
  [lang: string]: BranchLinksLocaleItem
}

interface BranchLinksSerializerInput {
  id: number
  ru: BranchLinksLocaleItem
  en: BranchLinksLocaleItem
  fr: BranchLinksLocaleItem
  de: BranchLinksLocaleItem
}

function branchLinksLocaleMap(
  data?: BranchLinksLocaleItem,
): BranchLinksLocaleItem {
  return {
    main_footer_app_store: data?.main_footer_app_store,
    main_footer_google_play: data?.main_footer_google_play,
    main_footer_app_gallery: data?.main_footer_app_gallery,
    category_footer_app_store: data?.category_footer_app_store,
    category_footer_google_play: data?.category_footer_google_play,
    category_footer_app_gallery: data?.category_footer_app_gallery,
    sidebar_button: data?.sidebar_button,
  }
}

export function BranchLinksSerializer(
  data?: BranchLinksSerializerInput,
): BranchLinks {
  return {
    ru: branchLinksLocaleMap(data?.ru),
    en: branchLinksLocaleMap(data?.en),
    fr: branchLinksLocaleMap(data?.fr),
    de: branchLinksLocaleMap(data?.de),
  }
}

export type BranchLinksGlobal = {
  [lang: string]: {
    app_store?: string
    google_play?: string
    app_gallery?: string
    sidebar_button?: string
  }
}
